import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bceb588c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup reports-menu-root" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "閾値超過履歴検索")
], -1))
const _hoisted_3 = { class: "popup-body calendar-controller" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "観測局名", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "内容", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "期間", -1))
const _hoisted_7 = { class: "date-selector" }
const _hoisted_8 = { class: "date" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "〜", -1))
const _hoisted_10 = { class: "date" }

import { ref, onMounted, computed } from 'vue'
import moment from 'moment'
import { RESOLUTIONS } from '@/components/common/ResolutionSelector.vue'
import DatePicker from '@/components/common/DatePicker.vue'
import StationSelector from '@/components/common/StationSelector.vue'
import { useGlobalStore } from '@/stores/globalStore'

type Props = {
  show: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
    show: { type: Boolean }
  },
  emits: ['search', 'update:show'],
  setup(__props: any, { emit }) {




const globalStore = useGlobalStore()
const thType = ref<string>('')
const startDate = ref(moment().subtract(1, 'month').toDate())
const endDate = ref(new Date())

const hide = () => emit('update:show', false)
const search = () => {
  const payload = {
    thType: thType.value,
    startDate: startDate.value,
    endDate: endDate.value,
  }
  emit('search', payload)
}

onMounted(() => {
  if (thTypes.value && thTypes.value.length > 0) {
    thType.value = thTypes.value[0].value
  }
})

const thTypes = computed(() => {
  const station = globalStore.currentStation

  return (
    station?.threshold
      .filter(t => t.level > 0)
      .map(t => {
        const label = t.title
        const value = `${t.target}_${t.status}`

        return {
          label,
          value,
        }
      }) ?? []
  )
})

return (_ctx: any,_cache: any) => {
  const _component_udc_select = _resolveComponent("udc-select")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("dl", null, [
        _hoisted_4,
        _createElementVNode("dd", null, [
          _createVNode(StationSelector, {
            "station-type": "all",
            silent: ""
          })
        ])
      ]),
      _createElementVNode("dl", null, [
        _hoisted_5,
        _createElementVNode("dd", null, [
          _createVNode(_component_udc_select, {
            modelValue: thType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((thType).value = $event)),
            options: _unref(thTypes)
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _createElementVNode("dl", null, [
        _hoisted_6,
        _createElementVNode("dd", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(DatePicker, {
              modelValue: startDate.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startDate).value = $event)),
              resolution: _unref(RESOLUTIONS).DAY
            }, null, 8, ["modelValue", "resolution"])
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(DatePicker, {
              modelValue: endDate.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endDate).value = $event)),
              resolution: _unref(RESOLUTIONS).DAY
            }, null, 8, ["modelValue", "resolution"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", { class: "popup-controls" }, [
      _createElementVNode("button", {
        onClick: hide,
        class: "btn btn-submit"
      }, "キャンセル"),
      _createElementVNode("button", {
        onClick: search,
        class: "btn btn-submit"
      }, "検索")
    ])
  ], 512)), [
    [_vShow, __props.show]
  ])
}
}

})